import { useState } from 'react'

import { ListAlt } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import WafersWithControlTable from 'Components/UI/Organisms/Vehicles/WafersWithControl'
import Add from 'Components/UI/Organisms/Vehicles/WafersWithControl/Add'
import Export from 'Components/UI/Organisms/Vehicles/WafersWithControl/Export'
import TemplateGlobal from 'Components/UI/Templates/Common'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

const TemplateWafersWithControl = () => {
  const [render, setRender] = useState(true)

  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()

  const { state: openExport, setOpen: setOpenExport, setClose: setCloseExport } = SetState()

  const [values, setValues] = useState({
    filters: [],
    rows: [],
    header: [],
    permissions: {},
  })

  const location = getUbicacion() || ''
  const { pathname } = useLocation()

  async function apiCall(options, callback) {
    setValues({
      filters: [],
      rows: [],
      header: [],
      permissions: {},
    })
    try {
      const result = await interfaces.wafersWithControlInterface.list(options)
      setValues({
        filters: result.data.filters,
        rows: result.data.data,
        header: result.header.header.count,
        permissions: result.data.permissions,
      })
      callback()
    } catch (error) {}
  }

  const BUTTONS = [
    {
      onClick: setOpenExport,
      menuTitle: 'Exportar',
      menuIcon: <ListAlt fontSize="small" />,
      buttonContent: 'Exportar',
      disabled: !values.permissions.managementInterface,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Agregar',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Agregar',
      buttonStartIcon: <AddIcon />,
      buttonStyle: values.permissions.managementInterface ? oemColorButton(pathname, location) : {},
      disabled: !values.permissions.managementInterface,
    },
  ]

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Vehículos" subTitle="Obleas con control" buttons={BUTTONS} />}
        table={
          <WafersWithControlTable
            render={render}
            setRender={setRender}
            data={values}
            apiCall={apiCall}
            setData={setValues}
          />
        }
      />

      {openExport.suspense && <Export open={setOpenExport} handleClose={setCloseExport} />}

      {openNew.suspense && (
        <Add
          data={values}
          render={render}
          setRender={setRender}
          handleClose={setCloseNew}
          open={setOpenNew}
        />
      )}
    </div>
  )
}

export default TemplateWafersWithControl
